export default "__VITE_ASSET__Bvh072G$__"